import { Platform } from "react-native";
import { APIService, getCarrierName } from "../utilities/Constants";
import { apiGet } from "./utils/apiUtils";
import { messages } from "../../src/resources/strings";

export const getAppUpdateInfo = async () => {
  const response = await apiGet<any>(
    APIService.harmony,
    `/app/version`,
    {},
    { policySource: getCarrierName() },
  );
  if (response?.status === 200 && response?.result) {
    return Platform.OS === "android"
      ? {
          enabledFeature: response.result.enabledFeature,
          ...response.result.update_info.android,
        }
      : {
          enabledFeature: response.result.enabledFeature,
          ...response.result.update_info.ios,
        };
  } else {
    return {
      response: null,
      errorCode: messages.error.somthingWrong,
    };
  }
};
